import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Globals } from '../globals';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { PermisoService } from './permiso.service';
import { Entidad } from '../interfaces/entidad';
import { GeneralService } from './general.service';

@Injectable()
export class PersonasService {
  constructor(
    private http: HttpInterceptor,
    private globals: Globals,
    private general: GeneralService,
    private permisoService: PermisoService
  ) { }


  getPersonas(
    paginado: any = {
      page: null,
      pageSize: null
    },
    orden: any = {
      sort: null,
      order: null
    },
    filtros: any = {
      generico: ''
    }): Observable<any> {
    return this.permisoService.getPermisoAction('PERSONAS-LISTADO')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + 'apiProspecto/getEntidades',
            JSON.stringify({
              idCliente:localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          )
          .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
            (respuesta: Response) => respuesta.json()

          );
      });
  }
  getColumnas(modelo: any): Observable<any> {
    // return this.permisoService.getPermisoAction('PERSONAS-LISTADO')
    // .switchMap((controllerAction) => {
      return this.http
        .post(
          this.general.webserver + 'apiEntidad/TableColumns',
          JSON.stringify({
            idCliente:localStorage.getItem('idCliente'),
            model: modelo,
          })
        )
        .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
          (respuesta: Response) => respuesta.json()

        );
    // });
  }
  filtroPersonalizado(
    paginado: any = {
      page: null,
      pageSize: null
    },
    orden: any = {
      sort: null,
      order: null
    },
    modelo: any,
    filtro: any
  ): Observable<any> {
    // return this.permisoService.getPermisoAction('PERSONAS-LISTADO')
    // .switchMap((controllerAction) => {
      return this.http
        .post(
          this.general.webserver + 'apiEntidad/Personalizados',
          JSON.stringify({
            idCliente:localStorage.getItem('idCliente'),
            model: modelo,
            paginado: paginado,
            orden: orden,
            filters: filtro
          })
        )
        .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
          (respuesta: Response) => respuesta.json()

        );
    // });
  }
  getCiudadProviciaPais(): Observable<any> {
    // return this.permisoService.getPermisoAction('PERSONAS-LISTADO')
    // .switchMap((controllerAction) => {
      return this.http
        .post(
          this.general.webserver + 'apiPaises/getPaisesLocalidadProvincia',
          JSON.stringify({
            idCliente:localStorage.getItem('idCliente')
          })
        )
        .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
          (respuesta: Response) => respuesta.json()

        );
    // });
  }
}